import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const BadgeWidget: WidgetRegistryEntry = {
  name: "Badge",
  configuration: () => import("./configuration").then((m) => m.BadgeWidgetConfiguration),
  component: () => import("./badge-widget.component").then((m) => m.BadgeWidgetComponent)
};
